module.exports = __webpack_public_path__ + "img/programaCompetencias.d2e6128d.png";